import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

const Authorizations = loadable(() => import('@/pages/CRM/Authorizations')); // prettier-ignore
const PriorAuthorizations = loadable(
  () => import('@/pages/CRM/Screener/PalAuthorizations')
); // prettier-ignore
const ConcurrentReviews = loadable(
  () => import('@/pages/CRM/Screener/PalReauths')
); // prettier-ignore
const CarveOutsTracking = loadable(
  () => import('@/pages/CRM/Screener/CarveOutsTracking')
); // prettier-ignore
const CarveOutDetail = loadable(
  () => import('@/pages/CRM/Screener/CarveOutsTracking/CarveOutDetail')
); // prettier-ignore

export enum CRMAuthorizationsRoutes {
  CRMAuthorizations = '/crm/authorizations',
  CRMAuthorizationsPriorAuthorizations = '/crm/authorizations/prior-authorizations',
  CRMAuthorizationsConcurrentReviews = '/crm/authorizations/concurrent-reviews',
  CRMAuthorizationsCarveOuts = '/crm/authorizations/carve-outs',
  CRMAuthorizationsCarveOutDetail = '/crm/authorizations/carve-outs/:id'
}

export const getCrmAuthorizationsRoutes = (): RouteObject[] => {
  return [
    {
      path: CRMAuthorizationsRoutes.CRMAuthorizations,
      element: <Authorizations />,
      children: [
        {
          path: CRMAuthorizationsRoutes.CRMAuthorizationsPriorAuthorizations,
          element: <PriorAuthorizations />
        },
        {
          path: CRMAuthorizationsRoutes.CRMAuthorizationsConcurrentReviews,
          element: <ConcurrentReviews />
        },
        {
          path: CRMAuthorizationsRoutes.CRMAuthorizationsCarveOuts,
          element: <CarveOutsTracking />
        },
        {
          path: CRMAuthorizationsRoutes.CRMAuthorizationsCarveOutDetail,
          element: <CarveOutDetail />
        }
      ]
    }
  ];
};
